import {
  ADD_ATTEND_EMP,
  ADD_REQUEEST_EMP,
  GET_ATTEND_EMP,
  GET_REQUEST_EMP,
} from "../type";
import { InsertData, InsertDataWithImage } from "../../Hooks/InsertData";
import { GetDataToken } from "../../Hooks/getAllData";
export const CreateRequestEmpAction = (data) => async (dispatch) => {
  try {
    const respons = await InsertData(
      `/api/EmployeePage/CreateEmployeeAdministrativeRequest`,
      data
    );
    dispatch({
      type: ADD_REQUEEST_EMP,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: ADD_REQUEEST_EMP,
      payload: "Error" + e,
    });
  }
};
export const CreateAttendEmpAction = (data) => async (dispatch) => {
  try {
    const respons = await InsertDataWithImage(
      `/api/EmployeePage/AddAttendance`,
      data
    );
    dispatch({
      type: ADD_ATTEND_EMP,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: ADD_ATTEND_EMP,
      payload: "Error" + e,
    });
  }
};
export const GetAllRequestEmpAction = (quary) => async (dispatch) => {
  try {
    const respons = await GetDataToken(
      `/api/EmployeePage/GetEmployeeAdministrativeRequest`,
      quary
    );
    dispatch({
      type: GET_REQUEST_EMP,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: GET_REQUEST_EMP,
      payload: "Error" + e,
    });
  }
};
export const GetAllAtendEmpAction = (quary) => async (dispatch) => {
  try {
    const respons = await GetDataToken(
      `/api/EmployeePage/GetEmployeeAttendance?${quary}`
    );
    dispatch({
      type: GET_ATTEND_EMP,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: GET_ATTEND_EMP,
      payload: "Error" + e,
    });
  }
};
